<script setup lang="ts">
import { PlusIcon, TimesIcon } from "@voltalis/ui-kit/icons";

import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { useTypedIntl } from "@/locales/typed-intl";

import CategoryCreationForm from "@/components/tools/site-section/category-creation/category-creation-form.vue";
import HospitalityButton from "@/components/ui/buttons/hospitality-button.vue";

const props = defineProps<{
  isCategoryCreationFormVisible: boolean;
  isCreatingCategory?: boolean;
  canCreateCategory: boolean;
  canClearCategory: boolean;
  clearCategoryLabel?: string;
}>();

const emit = defineEmits<{
  clearCategory: [];
  confirmCategoryCreation: [categoryName: string];
  resetCategoryCreationForm: [];
  startCategoryCreation: [];
}>();

const { t, k } = useTypedIntl();
</script>

<template>
  <div
    v-if="props.canCreateCategory || props.canClearCategory"
    class="border-t p-4"
  >
    <template v-if="props.isCategoryCreationFormVisible">
      <CategoryCreationForm
        :is-loading="props.isCreatingCategory"
        @confirm="emit('confirmCategoryCreation', $event)"
        @cancel="emit('resetCategoryCreationForm')"
      />
    </template>

    <div
      v-else
      class="flex flex-col gap-3"
    >
      <HospitalityButton
        v-if="props.canClearCategory"
        :data-test-id="DATA_TEST_IDS.components.siteSectionsTreeSectionCategoryFilter.clearButton"
        :icon="TimesIcon"
        severity="link"
        size="xs"
        @click="emit('clearCategory')"
      >
        {{ props.clearCategoryLabel ?? t(k.global.misc.clearAll) }}
      </HospitalityButton>

      <HospitalityButton
        v-if="props.canCreateCategory"
        :data-test-id="DATA_TEST_IDS.components.siteSectionsTreeSectionCategoryFilter.createButton"
        :icon="PlusIcon"
        severity="link"
        size="xs"
        @click="emit('startCategoryCreation')"
      >
        {{ t(k.tools.siteManagement.siteTreeStructure.createCategory) }}
      </HospitalityButton>
    </div>
  </div>
</template>
